import React, { ReactElement, useContext, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { FeedbackOutlined } from "@mui/icons-material";
import { useTextDomainContext, useUser } from "@/app/providers";
import { FeedbackModal } from "./FeedbackModal";

/**
 * Floating feedback trigger button rendered at bottom-right of the viewport.
 * Hidden by default to prevent overlaying important content on screens.
 * Feedback is permanently accessible via the top navigation bar (FeedbackTopButton)
 * and the user profile dropdown menu.
 */
export const FeedbackButton = (): ReactElement | null => {
  return null;
};

/**
 * Top bar icon button for AppBar header
 */
export const FeedbackTopButton = (): ReactElement | null => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { user } = useUser();
  const [open, setOpen] = useState(false);

  if (!user) {
    return null;
  }

  return (
    <>
      <Tooltip title={gettext("Send Feedback / Report an issue")} arrow>
        <IconButton
          color="inherit"
          aria-label={gettext("Send Feedback")}
          onClick={() => setOpen(true)}
          sx={{
            mx: 0.5,
            color: "grey.700",
            "&:hover": {
              backgroundColor: "grey.100",
              color: "primary.main",
            },
          }}
        >
          <FeedbackOutlined sx={{ fontSize: 22 }} />
        </IconButton>
      </Tooltip>

      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
